module.exports = __webpack_public_path__ + "static/media/footer-logos-plataforma.7479a96f.svg";